import { useParams, Link } from 'react-router-dom'
import { HrSection } from '../primitives/HrSection'
import { Badge } from '../../../../shared/ui'

const LABELS: Record<string, string> = {
  'bank-steuer':    'Bank & Steuer',
  'beschaeftigung': 'Beschäftigung',
  'zeiterfassung':  'Zeiterfassung',
  'lohn':           'Lohn & DATEV',
  'urlaub':         'Urlaub',
  'krank':          'Krank',
  'compliance':     'Compliance',
  'dokumente':      'Dokumente',
  'notizen':        'Notizen',
  'historie':       'Historie',
  'offboarding':    'Offboarding',
}

// Placeholder rendered for hr-person-* tabs that have been registered in the
// permission system + sidebar but whose UI ships in a later session. Keeps the
// sidebar honest (no dead links) and gives the operator a clear "in progress"
// signal instead of silently rendering Übersicht again.
export default function TabPlaceholder() {
  const { tabId, mainId } = useParams<{ tabId?: string; mainId?: string }>()
  const label = (tabId && LABELS[tabId]) ?? tabId ?? 'Tab'

  return (
    <HrSection
      title={label}
      subtitle="Dieser Tab wird in einer kommenden Session gebaut."
      actions={<Badge tone="info" outlined>Bald verfügbar</Badge>}
    >
      <div className="rounded-2xl border border-dashed border-outline-variant/60 bg-surface-container-lowest/60
                      p-10 text-center space-y-3">
        <span className="material-symbols-outlined text-4xl text-on-surface-variant/60" aria-hidden="true">
          construction
        </span>
        <h3 className="text-base font-semibold text-on-surface">"{label}" ist noch in Vorbereitung</h3>
        <p className="text-sm text-on-surface-variant max-w-md mx-auto">
          Permission-Eintrag und Sidebar-Slot stehen. Der Tab-Inhalt folgt in einer
          späteren Wave — siehe Handover für die Reihenfolge.
        </p>
        <div className="pt-2">
          <Link
            to={`/hr/personen/${mainId}/uebersicht`}
            className="text-sm font-medium text-primary hover:underline"
          >
            Zur Übersicht zurück →
          </Link>
        </div>
      </div>
    </HrSection>
  )
}
